export default "__VITE_ASSET__C_lFtAk6__"